import axios from "axios";
import dayjs from './dayjs-setup';
 // without this line it didn't work
dayjs.locale('es');


const App_sesion_token_key = "App_service_token";
const App_store__token = "app_store__token";




 const AxiosInstance = axios.create({
  baseURL:import.meta.env.VITE_API_SERVICE,
  });

const LogisticoAxiosInstance = axios.create({
  baseURL:import.meta.env.VITE_API_SERVICE,
  
});

const AxiosCentrasService = axios.create({
  baseURL:import.meta.env.VITE_CENTRAL_SERVICE,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
  
});




AxiosInstance.interceptors.request.use( config=>{

    config.headers['Authorization'] = "Bearer "+localStorage.getItem(App_sesion_token_key);
    config.headers['authorization'] = "Bearer "+localStorage.getItem(App_sesion_token_key);


    return config;
}); 

AxiosInstance.interceptors.response.use(response=>{
  return response;
},function(error){
  
  if ( error?.response?.status === 401 && localStorage.getItem(App_sesion_token_key) ){
      localStorage.removeItem(App_sesion_token_key);

      window.location = '/';
      window.location.reload();
      
  }
  return Promise.reject(error);
  console.log(error.response);
})



export const LocaleYupValidation = {
    mixed: {
        default: 'Campo no valido',
        required: 'El campo es obligatorio',
        oneOf: 'Debe colocar uno de los siguientes valores: ${values}',
        notOneOf: 'No puede ser ninguno de los valores: ${values}',
        notType: ({ type }) => (type === 'number' ? 'Debe ser un numero' : 'Campo no valido')
      },
      string: {
        length: 'Debe tener exactamente ${length} caracteres',
        min: 'Debe tener Minimo ${min} caracteres',
        max: 'Debe tener Maximo ${max} caracteres',
        email: 'E-mail no valido',
        url: 'La url no es valida',
        trim: 'No debe contener espacios',
        lowercase: 'Debe estar en minuscula',
        uppercase: 'Debe estar en  mayuscula'
      },
      number: {
        min: 'Debe ser minimo ${min}',
        max: 'No debe ser mayor a ${max}',
        lessThan: 'Debe ser menor que ${less}',
        moreThan: 'Debe ser mayor que ${more}',
        // notEqual: 'Não pode ser igual à ${notEqual}',
        positive: 'Debe ser un numero positivo',
        negative: 'Debe ser un numero negativo',
        integer: 'Debe ser un numero entero'
      },
      date: {
        min: 'Debe ser menor que ${min}',
        max: 'Debe ser mayor que ${max}'
      },
      array: {
        min: 'Debe tener minimo ${min} items',
        max: 'Debe tener máximo ${max} items'
      },
}

const ModalpropsCustom = {
  isVisible:false,
  type:"",

  title:"",
  messsage:"",
 
}

export const Perfiles = {
  "proveedor":1,
  "comprador":2,
  "administrador":3,
  "logistico":5,
  "cliente":6,
  "comprador_acercate":7,
  "proveedor-logistico":8,
  "vendedor":9,
  "agente-regional":10,
  "recibidor":11,
  "exportador-plano":12,
  "lider-ventas":13,
  "administrador-punto-venta":14,
  "alistador":15
  
}
export const TiposEmpresas = {
  "INDEPENDIENTE":"Independiente",
  "EMPRESA":"Empresa"
};
export const MotivosIngreso = {
  "SIN_NOVEDAD":"SIN NOVEDAD",
  "BONIFICACION":"BONIFICACION",
  "AVERIA":"CON AVERIA",// el producto presenta averias o no cumple con las condiciones de aceptacion
  //"DEVOLUCION":"DEVOLUCION",
  "PRODUCTO_NO_PEDIDO":"PRODUCTO NO PEDIDO",//es cuando hay mayor cantidad de producto facturado
  "MERCANCIA_NO_RECIBIDA":"MERCANCIA NO RECIBIDA",
  "DEVOLUCION_POR_CALIDAD":"CALIDAD DIFERENTE" // se recibe el producto en calidad diferente
}
export const ObtenerTipoDocumentos = {
  EA:"ENTRADA AL ALMACEN",
  ER:"ENTRADA POR RECLASIFICACION",
  NP:"NOTA AL PROVEEDOR",

}
export const GetStatusIngreso = {
  BORRADOR:"En borrador",
  TRANSMITIDA:"Transmitida",
  CON_ERROR:"Con error",
  ANULADO:"ANULADO"
}

const sortFunctions = {
  sortString:(array = [],keySort,sortValue='ASC')=>{

   return  array.sort( (itemA,itemB)=>sortValue === 'ASC'?itemA[keySort].localeCompare( itemB[keySort] ):(-1)*itemA[keySort].localeCompare( itemB[keySort] )   );

  },
  sortNumber:(array = [],keySort,sortValue='ASC')=>{

  return  array.sort( (itemA,itemB)=>sortValue === 'ASC'? itemA[keySort] - itemB[keySort]: (-1 * (itemA[keySort] - itemB[keySort])  )   );

  }
}
 const DialogType = {
  exitoso:"success",
  informativo:"info",
  peligro:"danger"
}
const TiposVehiclos = {
  Refrigerado:"REFRIGERADO",
  "No-Refrigerado":"NO REFRIGERADO"
}
const FormActions = {
  AGREGAR:"AGREGAR",
  MODIFICAR:"MODIFICAR"
}
const EntityStatus = {
  HABILITADO:"SI",
  DESHABILITADO:"NO"
}
 const DateFormatString = "YYYY-MM-DD";
 const DateTimeFormatString = "YYYY-MM-DD HH:mm:ss";
const TipoVehiculoEntity ={
  cod:null,
  descripcion:"",
  largo:null,
  ancho:null,
  alto:null,
  tipo:""
}
const RutaEntity = {
  municipio_origen:null,
  municipio_destino:null,
  fecha_desde:null
}
const usuarioEntity = {
  usuario:"",
  razon_social:"",
  celular:"",
  email:"",
  clave:"",
  pass:"",
  perfil:null,
  productos_asociados:[],
  agente_asociado:null,
  activo:null
}


const generateCodSobreCosto = (Entity)=>{
  return `${Entity.cod_municipio_origen}-${Entity.cod_municipio_destino}-${Entity.fecha_desde}`
}
const getLabelMunicipio = (depa,mun)=>{
 return  `${depa} - ${mun}`;
}
const FormatPrice = (value,fixed_value = 3)=>{
 // console.log({value,trim:String( value ).trim().trimEnd().replace(/[^0-9.]/g,"")});
  
 let valueFomat = Intl.NumberFormat("es-CO",{}).format(Number(  String( value ).replace(/[^0-9.]/g,"").trim().trimEnd()  ).toFixed(fixed_value));
   const arrayItems = valueFomat.split(",");
   //return valueFomat;
   if (  !!arrayItems[1] &&  arrayItems[1].length > 0){
    arrayItems[1] =  arrayItems[1].padEnd(fixed_value,'0');
   }
   return  arrayItems.join(",");

    
}

const toQty = (value)=>{
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return 0;
  }
  return Number(n.toFixed(3));
}

const CalculateInputsColNecesidades = (productos)=>{

  let colsDetalle = [];
  productos.forEach( (item,key)=>{
         item.detalle.forEach( (subItem,keySubitem)=>{
               if (!colsDetalle.find(det=>det.cod === subItem.co_salida.cod_municipio)){
                 colsDetalle.push({
                   cod:subItem.co_salida.cod_municipio,
                   nombre:subItem.co_salida.nombre_municipio,
  
                 })
               }   
         } )
    
    } );
   let NewDataMapped = productos.map( (item,key)=>{
     let newColDetalle = [...colsDetalle.map(col=>({...col,valueUME:0,valueUMI:0}))];
     item.detalle.forEach( (subItem,keySubitem)=>{
         let index = newColDetalle.findIndex(det=>det.cod === subItem.co_salida.cod_municipio);
           if ( index !== -1 ){
             newColDetalle[index].valueUME = toQty(newColDetalle[index].valueUME) + toQty(subItem.cantidad);
             newColDetalle[index].valueUMI = toQty(newColDetalle[index].valueUMI) + toQty(subItem.cantidad) * toQty(item.conversion_peso);
            
           }   
     } )
  
     return {...item,total_items:newColDetalle};
  
  } );
  colsDetalle.push({
    cod:-1,
    nombre:"Cons RQS",
  
  });
  NewDataMapped = NewDataMapped.map( (item,key)=>{
    let totalSumUme =  item.total_items.reduce((total,col)=>toQty(total) + toQty(col.valueUME),0);
    let totalSumUmi =  item.total_items.reduce((total,col)=>toQty(total) + toQty(col.valueUMI),0);
    item.total_items.push({
      cod:-1,
      nombre:"Cons RQS",
      valueUME:toQty(totalSumUme),
      valueUMI:toQty(totalSumUmi)
    });
  
  return item;
  })

  return {colsDetalle,NewDataMapped};

}
export const parseNumber  = (value)=>{
  return String( value ).replace(/,/g,".").replace(/e/g,"");
}
function isIntNumber(value) {
   value = parseNumber(value);
 
  return isNaN(Number(value)); 
}

const getUrlImage = (image_name)=>{
  return import.meta.env.VITE_AWS_STORAGE+"/"+image_name;
}

 const NecesidadTypes = {
  PROPIA:'interna',
  TERCERO:'externa'
}

const ParseStateNecesidad = {
  "-1":null,
  "0":false,
  "1":true
}

const EstadosPedido = {
  "CREADO":{
    label:"CREADO",
    color:"default"
  },
  "EN-ESPERA":{
    label:"En espera",
    color:"default"
  },
  "RECIBIDO":{
    label:"CONFIRMADO",
    color:"success",
    
  },
  "EN-PROCESO":{
    label:"EN PROCESO",
    color:"warning",
  },
  "EN-ALISTAMIENTO":{
    label:"EN ALISTAMIENTO",
    color:"secondary",
  },
  "ALISTADO":{
    label:"ALISTADO",
    color:"secondary",
  },
  "POR-FACTURAR":{
    label:"POR FACTURAR",
    color:"secondary",
  },
  "EN-FACTURACION":{
    label:"EN FACTURACION",
    color:"warning",
  },
  "FACTURADO":{
    label:"Facturado",
    color:"success",
  },
  "EN-PROCESO":{
    label:"EN PROCESO",
    color:"primary",
  },

  "ENTREGADO":{
    label:"ENTREGADO",
    color:"success",
    
  },
  "EN-TRANSPORTE":{
    label:"EN TRANSPORTE",
    color:"warning",
    
  },
  "CANCELADO":{
    label:"CANCELADO",
    color:"error"
  },
  "VENCIDO":{
    label:"VENCIDO",
    color:"error"
  },
  "PROCESADO-CON-ERROR":{
    label:"CON ERRORES",
    color:"error"
  },
}

const EstadosItemsAlistamiento = {
  "PARCIAL":{
    label:"PARCIAL",
    color:"warning"
  },
  "COMPLETO":{
    label:"COMPLETO",
    color:"success"
  },
  "SOBRESTOCK":{
    label:"SOBRESTOCK",
    color:"info"
  },
  "NO_ENCONTRADO":{
    label:"SIN-STOCK",
    color:"error",
  },
  "PENDIENTE":{
    label:"PENDIENTE",
    color:"default",
  },
  
}

const TiposPedidos = {
  "PEDIDO":'Pedido',
  "COTIZACION":'Cotizacion',
  "SOLICITUD":'Solicitud',
 
}
export const TiposOfertas = {
  "AUTOMATICAS":"Automaticas",
  "ESPECIALES":"Especiales",
  "MANUALES":"Manuales"
}


export  const GetStatusAlert = status=>{
      
  if ( status === 'POR CONFIRMAR' ){
    return "warning";
  }
  if ( status === 'BORRADOR' ){
    return "info";
  }
  if ( status === 'CONFIRMADA' || status === 'TRANSMITIDA' ){
    return "success";
  }
  if ( status === 'RECHAZADA' || status === "ANULADO" ){
    return "error";
  }
  return "default";
}


export  const GetStatusPlanoConfig = status=>{
      
  if ( status === 'CREADO' ){
    return {
      color:"default",
      name:"En espera"
    };
  }
  if ( status === 'EN_PROCESO' ){
    return {
      color:"warning",
      name:"Procesando"
    };
  }
  if ( status === 'TERMINADO' ){
    return {
      color:"success",
      name:"Procesado"
    };
  }
  if ( status === 'CON_ERROR' ){
    return {
      color:"error",
      name:"Procesado con errores"
    };
  }
  return "default";
}
const FileToBase64DataURL = blob => new Promise(  
  resolvePromise => {
      const reader = new FileReader();
      reader.onload = (e) =>{
        var base64Content = e.target.result.split(',')[1];
        var utf8Content = btoa(decodeURIComponent(encodeURIComponent(base64Content)));
        resolvePromise(utf8Content)
      } ;
      reader.readAsDataURL(blob);
  }
);
const ExtensionFiles = {
  "text/plain":".txt"
}
function CapitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}


const IsBeforeNowDate = (dateIn)=>{
  return dayjs().isAfter(dateIn);
}

const getCalculateEntregaData = (detalle_list=[])=>{
  var dates = {
   min:detalle_list[0].fecha_entrega,
   max:detalle_list[0].fecha_entrega,
   num_days:0
  };
  detalle_list.forEach(date_item=>{
     if (dayjs(date_item.fecha_entrega).isBefore(dates.min)){
       dates.min = date_item.fecha_entrega;
     }
     if( dayjs(date_item.fecha_entrega).isAfter(dates.max) ){
       dates.max = date_item.fecha_entrega;
     }
  });

  dates.num_days = dayjs(dates.max).diff(dayjs(dates.min),"days");
  dates.num_days += 1;

  return dates;

}

 const TiposEntregaCheck = {
  "ED":"ENVIO A DOMICILIO",
  "EE":"ENVIO EXPRESS",
  "RT":"RECOGER EN TIENDA",
  "EI":"ENTREGA INMEDIATA"
}

const CreditosTipo = {
    "03A":"CREDITO A 3 DIAS",
    "08F":"CREDITO A 8 DIAS",
    "15C":"CREDITO A 15 DIAS"
}

const ContralServiceUrl = import.meta.env.VITE_CENTRAL_SERVICE;

const TipoPersona = {
  "EMPRESA":"Empresa",
  "PERSONA-NATURAL":"Persona natural"
};

const getRouteObject = (jsObject,route='')=>{
   let value = null;
   route.split(".").forEach(key=>{
    if ( value){
      value = value[key];
      return;
    }
     value = jsObject[key];

   });
   return value;
}

const getStatusPedido = ({cantidad,cantidad_inv})=>{
  console.log({cantidad,cantidad_inv});
  if ( cantidad_inv == '' || cantidad_inv == null ){
    return "PENDIENTE";
  }
  if ( Number(cantidad_inv) === 0 ){
    return "NO_ENCONTRADO";
  }
  
   if ( Number(cantidad_inv) === Number(cantidad) && Number(cantidad_inv) > 0 ){
     return "COMPLETO";
   }
   if ( Number(cantidad_inv) > Number(cantidad) && Number(cantidad_inv) > 0 ){
    return "SOBRESTOCK";
  }
   if ( Number(cantidad_inv) < Number(cantidad)  && Number(cantidad_inv) > 0){
    return "PARCIAL";
  }

 }

export {
  getStatusPedido,
  getRouteObject,
  TipoPersona,
  CreditosTipo,
  getCalculateEntregaData,
  CapitalizeFirstLetter,
  ExtensionFiles,
  FileToBase64DataURL,
  ContralServiceUrl,
  LogisticoAxiosInstance,
  getUrlImage,
  TiposPedidos,
  EstadosPedido,
  ParseStateNecesidad,
    NecesidadTypes,
    App_sesion_token_key,
    AxiosInstance,
    ModalpropsCustom,
    App_store__token,
    sortFunctions,
    DialogType,
    TiposVehiclos,
    TipoVehiculoEntity,
    FormActions,
    EntityStatus,
    RutaEntity,
    generateCodSobreCosto,
    getLabelMunicipio,
    FormatPrice,
    DateFormatString,
    usuarioEntity,
    CalculateInputsColNecesidades,
    isIntNumber,
    AxiosCentrasService,
    DateTimeFormatString,
    TiposEntregaCheck,
    IsBeforeNowDate,
    EstadosItemsAlistamiento
}